export const OCC_ENDPOINTS = {
  infoblocks: '/infoblocks/',
};
